import { Box, Typography } from '@material-ui/core';
import { Link } from '@backstage/core-components';

export const ScaffolderGroupTitleGcpDataPlatform = () => {
  return (
    <Box>
      <Typography variant="h4">Self-Service Data Platform on GCP</Typography>
      <Typography paragraph>
        Provision standardized, governed, and production-ready data platform
        components on Google Cloud. Learn more about the{' '}
        <Link to="/docs/default/Component/gcp-dataplatform-doc">
          GCP Data Platform
        </Link>
        .
      </Typography>
    </Box>
  );
};
